import * as React from "react";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

export const ReportLocalTimeLabel: React.FC = () => (
  <Flex alignItems="center" justifyContent="center" marginTop={withVar(SpacingToken.Spacing2)}>
    <Text size="sm" customColor={withVar(DesignToken.ContentBasicDisabled)}>
      All reports are displayed in your local time.
    </Text>
  </Flex>
);
